export const UnknownPaymentDetails = () => {
    return (
        <div>
            <h1>Unknown Payment Details</h1>
        </div>
    )
}
